
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about6Vgf2e_45ZWwa_45DDxcsm2LFgKBFkBxwt_su_XdCkSeybIMeta } from "/opt/buildhome/repo/pages/about.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as termsM_RN9_459iuNVtH23UOLrjvoINYU4b2nnq0grhd_RmiYYMeta } from "/opt/buildhome/repo/pages/terms.vue?macro=true";
import { default as privacyArxgULVZ2Zifu3wQfKQ0WvqaXaBxDlpI2F7eal9OET8Meta } from "/opt/buildhome/repo/pages/privacy.vue?macro=true";
import { default as product4QByzMGGQRO44k21wJZotgRNIGH_5Xi_kx8XweCkaH4Meta } from "/opt/buildhome/repo/pages/product.vue?macro=true";
import { default as customerscsQkqBSMO_45Dhje_45_45R0LA7Qkz5JxFVudJRh4eNpFIQYIMeta } from "/opt/buildhome/repo/pages/customers.vue?macro=true";
import { default as providersfVnMfOU7JoTCg7onF_Z_1w8NLcn9V4SbKRRc7q9wU0cMeta } from "/opt/buildhome/repo/pages/providers.vue?macro=true";
import { default as indexBeHzAQikKrSJqk6imgHKGnYps5J2m1dpAlMAyv_MDnQMeta } from "/opt/buildhome/repo/pages/blog/index.vue?macro=true";
import { default as businessesdu5wXwtu_457_45kyPly_45mw59qavQJWbwaOU4hVKSASw8ysMeta } from "/opt/buildhome/repo/pages/businesses.vue?macro=true";
import { default as index_c3jpa56HsS51E7wMHiGzRe1CM7LevyxL9ojs75Bh_kMeta } from "/opt/buildhome/repo/pages/blog/[slug]/index.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/buildhome/repo/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsM_RN9_459iuNVtH23UOLrjvoINYU4b2nnq0grhd_RmiYYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyArxgULVZ2Zifu3wQfKQ0WvqaXaBxDlpI2F7eal9OET8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "product",
    path: "/product",
    component: () => import("/opt/buildhome/repo/pages/product.vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/opt/buildhome/repo/pages/customers.vue")
  },
  {
    name: "providers",
    path: "/providers",
    component: () => import("/opt/buildhome/repo/pages/providers.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/opt/buildhome/repo/pages/blog/index.vue")
  },
  {
    name: "businesses",
    path: "/businesses",
    component: () => import("/opt/buildhome/repo/pages/businesses.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: index_c3jpa56HsS51E7wMHiGzRe1CM7LevyxL9ojs75Bh_kMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blog/[slug]/index.vue")
  }
]